import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SelectionComponent from './SelectionComponent';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';

export interface SoloComponentProps {}

const SoloComponent: React.FC<SoloComponentProps> = () => {
  const next = useNextStepAfterUpdate();
  const { t } = useTranslation();
  const handleClick = (isSolo: boolean) => {
    next({ solo: isSolo });
  };

  const answers = [
    { title: t('home.input.dialog.soloRecording.solo'), key: true },
    { title: t('home.input.dialog.soloRecording.multiple'), key: false },
    { title: t('home.input.dialog.unknown'), key: null },
  ];

  return <SelectionComponent answers={answers} handleClick={handleClick} id="solo" />;
};

export default SoloComponent;
